




import { Vue, Component, Prop } from "vue-property-decorator";
import { getInternetExplorerVersion } from "../utils/getInternetExplorerVersion";

let isIE: boolean;
let isInit = false;

function initCompat() {
  if (!isInit) {
    isInit = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}

@Component
export default class ResizeObserver extends Vue {
  /* Props */
  @Prop({ default: false })
  emitOnMount!: boolean;

  @Prop({ default: false })
  ignoreWidth!: boolean;

  @Prop({ default: false })
  ignoreHeight!: boolean;

  @Prop()
  elemSelector?: string;

  /* Variables */
  store: {
    w: number;
    h: number;
    elem: HTMLElement | null;
    resizeObject: HTMLObjectElement | null;
  } = {
    w: 0,
    h: 0,
    elem: null,
    resizeObject: null,
  };

  /* Lifecycle hooks */
  mounted() {
    initCompat();
    this.$nextTick(() => {
      this.store.w = this.store.elem?.offsetWidth as number;
      this.store.h = this.store.elem?.offsetHeight as number;
      if (this.emitOnMount) {
        this.emitSize();
      }
    });
    this.store.elem = this.elemSelector
      ? this.elemSelector == "body"
        ? document.body
        : document.getElementById(this.elemSelector)
      : (this.$el as HTMLElement);
    const object = document.createElement("object");
    this.store.resizeObject = object;
    this.store.resizeObject.setAttribute("aria-hidden", "true");
    this.store.resizeObject.setAttribute("tabindex", "-1");
    this.store.resizeObject.onload = this.addResizeHandlers;
    this.store.resizeObject.type = "text/html";
    if (isIE) {
      this.store.elem?.appendChild(this.store.resizeObject);
    }
    this.store.resizeObject.data = "about:blank";
    if (!isIE) {
      this.store.elem?.appendChild(this.store.resizeObject);
    }
  }

  beforeDestroy() {
    this.removeResizeHandlers();
  }
  /* Methods */
  compareAndNotify() {
    if (
      (!this.ignoreWidth && this.store.w !== this.store.elem?.offsetWidth) ||
      (!this.ignoreHeight && this.store.h !== this.store.elem?.offsetHeight)
    ) {
      this.store.w = this.store.elem?.offsetWidth as number;
      this.store.h = this.store.elem?.offsetHeight as number;
      this.emitSize();
    }
  }
  emitSize() {
    this.$emit("notify", {
      width: this.store.w,
      height: this.store.h,
    });
  }
  addResizeHandlers() {
    this.store.resizeObject?.contentDocument?.defaultView?.addEventListener(
      "resize",
      this.compareAndNotify
    );
    this.compareAndNotify();
  }
  removeResizeHandlers() {
    if (this.store.resizeObject && this.store.resizeObject.onload) {
      if (!isIE && this.store.resizeObject.contentDocument) {
        this.store.resizeObject.contentDocument?.defaultView?.removeEventListener(
          "resize",
          this.compareAndNotify
        );
      }
      this.store.elem?.removeChild(this.store.resizeObject);
      this.store.resizeObject.onload = null;
      this.store.resizeObject = null;
    }
  }
}
